import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AppConstants } from '../AppConstants';
import { AuthService } from '../service/auth.service';

@Injectable({ providedIn: 'root' })
export class AdminEntryGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate() {
    const user = this.authService.syncUserContext();
    const defaultRoutes = {
      1: '/tenants-grid',
      2: '/landing-page/admin-bookings',
      3: '/businesses'
    };
    const defaultRoute = defaultRoutes[user?.roleId];
    if (defaultRoute && this.authService.getStoredItem(AppConstants.SESSION_STORAGE_ACCESS_TOKEN) &&
        this.authService.getTokenExpiryTime() > 0) {
      return this.router.parseUrl(defaultRoute);
    }
    return true;
  }
}
